export const INDEX = '/dashboard';
export const ALL_COLLECTIONS = '/all-collections';
export const ALL_REGISTRATIONS = '/all-registrations';
export const PRODUCTS = '/products';
export const VIEW_PRODUCT = '/products/view/:id';
export const CHOOSE_TEMPLATE = '/products/choose-template';
export const CREATE_PRODUCT = '/products/create';
export const EDIT_PRODUCT = '/products/edit/:id';
export const SINGLE_PRODUCTS = '/products/:type';
export const SEARCH_PRODUCT_USERS = '/products/:type/search';
export const LOGIN = '/auth/sign-in';
export const RESET_PASSWORD_TWO = '/auth/otp-verification';
export const RESET_PASSWORD = '/auth/reset-password';
export const REGISTER = '/auth/sign-up';
export const ACTIVATE_EMAIL = '/auth/activate-email';
export const RESEND_EMAIL = '/auth/resend-email';
export const VERIFY_EMAIL = '/auth/verifying-email';
export const SETTINGS = '/settings';
export const TEAM_MEMBER_INVITATION = '/invitation/:invitationId';
export const SETTLEMENT = '/settlement';
export const SETTLEMENT_DETAIL = '/settlement/:settlementId';
export const WALLET = '/wallets';
export const ONBOARDING = '/onboarding';
export const BASE = '/';
export const TRANSACTIONS = '/transactions';
export const NEWSETTINGS = '/settings';
export const PROFILESETTINGS = '/settings/profile';
export const TEAMSETTINGS = '/settings/team';
export const SETTLEMENTSETTINGS = '/settings/settlement';
export const SECURITYSETTINGS = '/settings/security';
export const BUSINESSSETTINGS = '/settings/business';
export const CUSTOMERS = '/customers';
export const CUSTOMER_DETAILS = '/customers/:customerId';
export const CUSTOMER_CATEGORIES = '/customers/categories';
export const TEAMS = '/teams';
export const DEVICES = '/devices';
export const DOCUMENTATION = '/documentation';
export const GUIDES = '/guides';
export const REFERRAL = '/referral';
export const ACTIVITYLOG = '/activity-log';
export const TERMINAL_DETAILS = '/terminal/:id';
export const TERMINAL = '/terminal';
export const TERMINAL_ORDER = '/terminal/order';
